import { render, staticRenderFns } from "./teacherDialog.vue?vue&type=template&id=4e5f3aee"
import script from "./teacherDialog.vue?vue&type=script&lang=js"
export * from "./teacherDialog.vue?vue&type=script&lang=js"
import style0 from "./teacherDialog.vue?vue&type=style&index=0&id=4e5f3aee&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports